import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import MobileMenu from "../components/MobileMenu";
import PopupSearch from "../components/PopupSearch";
import ScrollToTop from "../components/ScrollToTop";

import { faqService } from "../pages/publicservice/FAQService";
import { FAQ as FAQType } from "../admin/interfaces/FAQ";

const FAQ: React.FC = () => {
   const [menuOpen, setMenuOpen] =  useState(false);
  const [faqs, setFaqs] = useState<FAQType[]>([]);
  const [activeIndex, setActiveIndex] = useState<number | null>(0);
  const [loading, setLoading] = useState<boolean>(true);

  const toggleAccordion = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  // ✅ Load FAQ from API
  useEffect(() => {
    const loadFaqs = async () => {
      try {
        setLoading(true);
        const data = await faqService.getActiveAll();
        setFaqs(data);
      } catch (error) {
        console.error("Failed to load FAQs:", error);
      } finally {
        setLoading(false);
      }
    };

    loadFaqs();
  }, []);

  return (
    <>
      <MobileMenu
  isOpen={menuOpen}
  onClose={() => setMenuOpen(false)}
/>
      <PopupSearch />

      <main className="main">
        <Header />

        {/* Breadcrumb */}
        <div
          className="breadcumb-wrapper"
          style={{
            backgroundImage: "url('/assets/img/bg/breadcumb-bg-4.jpg')",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
          }}
        >
          <div className="container z-index-common">
            <div className="breadcumb-content">
              <h1 className="breadcumb-title">FAQ's</h1>
            </div>
          </div>
        </div>

        {/* FAQ Section */}
        <section className="space space-bottom faq-main-section">
          <div className="container">
            <div className="row">
              <div className="col-lg-8 mx-auto">
                <h2 className="text-uppercase text-white mb-4 sec-title">
                  FAQ
                </h2>

                {loading ? (
                  <p style={{ color: "#fff" }}>Loading FAQs...</p>
                ) : (
                  <div className="accordion accordion-style1">
                    {faqs.map((faq, index) => (
                      <div className="accordion-item" key={faq.faqID ?? index}>
                        <h2 className="accordion-header">
                          <button
                            className={`accordion-button ${
                              activeIndex !== index ? "collapsed" : ""
                            }`}
                            type="button"
                            onClick={() => toggleAccordion(index)}
                            aria-expanded={activeIndex === index}
                            style={{
                              width: "100%",
                              textAlign: "left",
                              border: "none",
                              background: "transparent",
                            }}
                          >
                            {faq.question}
                          </button>
                        </h2>

                        <div
                          className={`accordion-collapse collapse ${
                            activeIndex === index ? "show" : ""
                          }`}
                        >
                          <div className="accordion-body">
                            {faq.answer}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </main>

      <ScrollToTop />
    </>
  );
};

export default FAQ;